import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router";
import { Provider as ReduxProvider } from "react-redux";
import * as Sentry from "@sentry/react";
import "./index.scss";
import "./doctor.scss";
import App from "./App";
import { store } from "./store";
import { UserProvider } from "./context/UserContext";
import ScrollToTop from "./components/ScrollToTop";
import { GoogleMapsProvider } from "./context/GoogleMapContext";
import ErrorBoundary from "./components/ErrorBoundary";
import { HelmetProvider } from "react-helmet-async";
import { QueryProvider } from "./queries";
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";

if (import.meta.env.VITE_SENTRY_DSN) {
  Sentry.init({
    dsn: import.meta.env.VITE_SENTRY_DSN,
    environment: import.meta.env.VITE_SENTRY_ENVIRONMENT || "staging",
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration(),
    ],
    tracesSampleRate: 1.0,
    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1.0,
  });
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <HelmetProvider>
    <ReduxProvider store={store}>
      <QueryProvider showDevtools={false}>
        <UserProvider>
          <GoogleMapsProvider>
            {/* <BrowserRouter basename="/tabsbook-frontend/"> */}
            <BrowserRouter basename="/">
              <ScrollToTop>
                <ErrorBoundary
                  fallback={
                    <h1 style={{ color: "#e20000", textAlign: "center", position: "absolute", top: "50%", left: "50%", transform: "translate(-50%, -50%)" }}>
                      There was an error.
                    </h1>
                  }>
                  <App />
                </ErrorBoundary>
              </ScrollToTop>
            </BrowserRouter>
          </GoogleMapsProvider>
        </UserProvider>
        <ReactQueryDevtools initialIsOpen={false} buttonPosition="bottom-right" />
      </QueryProvider>
    </ReduxProvider>
  </HelmetProvider>
);
